__turbopack_context__.v({
  "className": "space_mono_cb26fce4-module__4OvslG__className",
  "variable": "space_mono_cb26fce4-module__4OvslG__variable",
});
